<p>
  Всеки регистриран потребител разполага с личен рейтинг, който отразява неговата активност, коректност и общо
  поведение в платформата. Този рейтинг е публичен и служи като ориентир за останалите потребители при сключване на
  сделки.
</p>
<p>
  Колкото по-висок е рейтингът, толкова по-голямо е доверието в съответния профил. Той се формира въз основа на реални
  действия – като получени отзиви, активност в обявите и участие в търговията.
</p>
<h6 class="mt-3">
  Как се изчислява рейтингът?
</h6>
<p class="mb-1">
  Рейтингът е числова стойност, която се променя според следните условия:
</p>
<ul>
  <li><strong>-10</strong> – при получен отзив с оценка 0%</li>
  <li><strong>-5</strong> – при отзив с оценка 25%</li>
  <li><strong>+5</strong> – при отзив с оценка 75%</li>
  <li><strong>+10</strong> – при отзив с оценка 100%</li>
  <li><strong>+1</strong> – за всяка новосъздадена обява</li>
  <li><strong>+2</strong> – за всяка успешно осъществена покупка или продажба</li>
</ul>
<h6 class="mt-3">
  Нива и отличителни маркери
</h6>
<p>
  В зависимост от натрупаните точки, всеки потребител получава визуален маркер до името си. Това улеснява разпознаването
  на опитни, активни и надеждни участници в платформата.
</p>
<table class="table table-striped table-hover">
  <thead class="text-start">
  <tr>
    <th scope="col">Маркер</th>
    <th scope="col">Рейтинг</th>
  </tr>
  </thead>
  <tbody class="text-start">
  <tr>
    <th class="fw-normal" scope="row">Няма</th>
    <td>Под 0</td>
  </tr>
  <tr>
    <th scope="row"><i class="fa-solid fa-star text-muted"></i></th>
    <td>0 – 9</td>
  </tr>
  <tr>
    <th scope="row"><i class="fa-solid fa-star nz-color-star"></i></th>
    <td>10 – 49</td>
  </tr>
  <tr>
    <th scope="row"><i class="fa-solid fa-star nz-color-star"></i> <i class="fa-solid fa-star nz-color-star"></i></th>
    <td>50 – 199</td>
  </tr>
  <tr>
    <th scope="row"><i class="fa-solid fa-star nz-color-star"></i> <i class="fa-solid fa-star nz-color-star"></i> <i
      class="fa-solid fa-star nz-color-star"></i></th>
    <td>200 – 499</td>
  </tr>
  <tr>
    <th scope="row"><i class="fa-solid fa-gem nz-color-gem"></i></th>
    <td>500 – 999</td>
  </tr>
  <tr>
    <th scope="row"><i class="fa-solid fa-gem nz-color-gem"></i> <i class="fa-solid fa-gem nz-color-gem"></i></th>
    <td>1000 – 2499</td>
  </tr>
  <tr>
    <th scope="row"><i class="fa-solid fa-gem nz-color-gem"></i> <i class="fa-solid fa-gem nz-color-gem"></i> <i
      class="fa-solid fa-gem nz-color-gem"></i></th>
    <td>2500 – 4999</td>
  </tr>
  <tr>
    <th scope="row"><i class="fa-solid fa-crown nz-color-crown"></i></th>
    <td>5000 – 9999</td>
  </tr>
  <tr>
    <th scope="row"><i class="fa-solid fa-crown nz-color-crown"></i> <i class="fa-solid fa-crown nz-color-crown"></i>
    </th>
    <td>10000 – 19999</td>
  </tr>
  <tr>
    <th scope="row"><i class="fa-solid fa-crown nz-color-crown"></i> <i class="fa-solid fa-crown nz-color-crown"></i> <i
      class="fa-solid fa-crown nz-color-crown"></i></th>
    <td>Над 19999</td>
  </tr>
  </tbody>
</table>
<div class="m-0 alert alert-primary"><strong>Съвет:</strong> Преди да осъществите сделка, проверете рейтинга на
  потребителя. Високият рейтинг е добър индикатор за надеждност, активност и коректно поведение.
</div>
